import BaseModule from "~/vuex/modules/base-module";

let Role_users = {...BaseModule};

Role_users.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/role_users';

    return state;
};
export default Role_users;
